module.exports = __webpack_public_path__ + "static/media/minilogo.175aeaae.png";